import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptEssonne91 = () => {
  return (
    <DepartmentTemplate
      department="Essonne"
      departmentNumber="91"
      cities="Évry-Courcouronnes, Corbeil-Essonnes, Massy, Savigny-sur-Orge, Étampes"
      region="Île-de-France"
    />
  );
};

export default DeptEssonne91;
